import { triggerTracking } from '@zoopla/tracking';
import { triggerSegmentPropertyEvent } from '@zoopla/analytics/property-data';
import type { PropertyDataForAnalytics } from '@zoopla/analytics/property-data';
import { TrackedPropertyRelationship, Maybe } from '../graphql.generated';

export const recordDismissModal = (
    analyticsData: PropertyDataForAnalytics,
    existingRelationship: TrackedPropertyRelationship | null = null,
    isEditing: boolean
) => {
    const eventValue = analyticsData?.uprn
        ? parseInt(analyticsData.uprn, 10)
        : 0;

    if (isEditing) {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'tracked property details',
            eventAction: 'form closed',
            eventLabel: `edit relationship ${
                existingRelationship && existingRelationship.toLowerCase()
            }`,
            eventValue
        });
        return;
    }

    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'property details',
        eventAction: 'save',
        eventLabel: 'save property undefined',
        eventValue,
        taxonomy: {
            property_relationship: 'undefined'
        }
    });

    triggerSegmentPropertyEvent(
        analyticsData,
        'Track Property Success',
        'undefined'
    );
};

export const recordTrackOrUntrackProperty = (
    analyticsData: PropertyDataForAnalytics,
    isCurrentlyTracked: boolean,
    relationship?: Maybe<TrackedPropertyRelationship>
) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'property details',
        eventAction: isCurrentlyTracked ? 'remove' : 'save',
        eventLabel: 'save property',
        eventValue: analyticsData?.uprn ? parseInt(analyticsData.uprn, 10) : 0
    });

    if (isCurrentlyTracked) {
        triggerSegmentPropertyEvent(
            analyticsData,
            'Untrack Property',
            relationship
        );
    }
};

export const recordSaveRelationship = (
    analyticsData: PropertyDataForAnalytics,
    relationship: TrackedPropertyRelationship,
    existingRelationship: TrackedPropertyRelationship | null = null,
    isEditing: boolean
) => {
    const eventValue = analyticsData?.uprn
        ? parseInt(analyticsData.uprn, 10)
        : 0;

    if (isEditing) {
        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'tracked property details',
            eventAction: 'save',
            eventLabel: `edit relationship to ${relationship.toLowerCase()} from ${
                existingRelationship && existingRelationship.toLowerCase()
            }`,
            eventValue,
            taxonomy: {
                property_relationship: relationship.toLowerCase()
            }
        });
        return;
    }

    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'property details',
        eventAction: 'save',
        eventLabel: `save property ${relationship.toLowerCase()}`,
        eventValue,
        taxonomy: {
            property_relationship: relationship.toLowerCase()
        }
    });

    triggerSegmentPropertyEvent(
        analyticsData,
        'Track Property Success',
        relationship
    );
};
